import type React from 'react';
import Styles from './ConstructionTop.module.scss';
import type { DealConstructionContext } from '~/models/DealConstruction';
import { ConstructionAmounts } from './ConstructionAmounts';
import { ConstructionActions } from './ConstructionActions';

type Props = {
  readonly: boolean;
  constructionContext: DealConstructionContext;
  dealEstimationHistoryContext?: DealConstructionContext | null;
  dealEstimationDraftHeader?: DealConstructionContext | null;
  handleClickEstimationPreview?: (() => void) | null;
  handleClickEstimationHistoryPreview?: (() => void) | null;
  handleClickBillingPreview?: (() => void) | null;
  handleClickShowAddModal?: (() => void) | null;
  handleClickChangeAmount?: (() => void) | null;
  handleClickGenerateBillings?: (() => void) | null;
  handleClickCreateHeader?: (() => void) | null;
  handleClickDestroyHeader?: (() => void) | null;
  billingTarget?: 'owner' | 'rentee' | null;
  useSK?: boolean;
  estimationAddDisabled?: boolean;
  ownManagement?: boolean;
};

export const ConstructionTop: React.FC<Props> = ({
  readonly,
  constructionContext,
  dealEstimationHistoryContext = null,
  dealEstimationDraftHeader = null,
  handleClickEstimationPreview = null,
  handleClickEstimationHistoryPreview = null,
  handleClickBillingPreview = null,
  handleClickShowAddModal = null,
  handleClickChangeAmount = null,
  handleClickGenerateBillings = null,
  handleClickCreateHeader = null,
  handleClickDestroyHeader = null,
  billingTarget = null,
  useSK = false,
  estimationAddDisabled = false,
  ownManagement = false
}: Props) => (
  <div className={Styles.EstimateTop}>
    <ConstructionAmounts
      billingTarget={billingTarget}
      constructionContext={constructionContext}
      dealEstimationDraftHeader={dealEstimationDraftHeader}
      dealEstimationHistoryContext={dealEstimationHistoryContext}
      ownManagement={ownManagement}
    />
    <ConstructionActions
      billingTarget={billingTarget}
      constructionContext={constructionContext}
      dealEstimationDraftHeader={dealEstimationDraftHeader}
      dealEstimationHistoryContext={dealEstimationHistoryContext}
      estimationAddDisabled={estimationAddDisabled}
      handleClickBillingPreview={handleClickBillingPreview}
      handleClickChangeAmount={handleClickChangeAmount}
      handleClickCreateHeader={handleClickCreateHeader}
      handleClickDestroyHeader={handleClickDestroyHeader}
      handleClickEstimationHistoryPreview={handleClickEstimationHistoryPreview}
      handleClickEstimationPreview={handleClickEstimationPreview}
      handleClickGenerateBillings={handleClickGenerateBillings}
      handleClickShowAddModal={handleClickShowAddModal}
      ownManagement={ownManagement}
      readonly={readonly}
      useSK={useSK}
    />
  </div>
);
